const {
  GET_RESTOCK_SUBSCRIPTIONS_REQUEST,
  GET_RESTOCK_SUBSCRIPTIONS_SUCCESS,
  RESTOCK_SUBSCRIPTIONS_ERROR,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_RESTOCK_SUBSCRIPTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RESTOCK_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case RESTOCK_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
